import { Type } from '@angular/core';
import { MatSort } from '@angular/material/sort';

import { IColumn } from '../../interfaces/column.table';
import { RenderData } from '../../interfaces/render-data';
import { ITotal } from '../../interfaces/total.table';
import { AmountItemRendererComponent } from '../../item-renderer/item-renderers/item-renderers.module';

export class AmountColumn<T> implements IColumn<T> {
  header: string;
  sortField: string;
  renderer: Type<any>;
  total: ITotal<T>;
  renderData: RenderData;
  sortFunction?: (data: T[], sort: MatSort) => T[];

  constructor(
    header: string,
    value: (item: T) => number,
    sortField?: string,
    total?: ITotal<T>,
    renderData?: RenderData,
    sortFunc?: (data: T[], sort: MatSort) => T[]
  ) {
    this.header = header;
    this.sortField = sortField;
    this.value = value;
    this.renderer = AmountItemRendererComponent;
    this.total = total;

    if (renderData && renderData.width) {
      this.renderData = renderData;
    } else {
      this.renderData = new RenderData();
    }

    this.sortFunction = sortFunc;
  }

  value(item: any): any {}
}
